import createEnum from './createEnum';
import UAParser from 'ua-parser-js';

// Possible device types returned from `parser.getDevice().type
export const DEVICE_TYPE = createEnum('console', 'mobile', 'tablet', 'smarttv', 'wearable', 'embedded');

const getCustomerProperties = () => {
  const parser = new UAParser();
  let properties = {
    browser: parser.getBrowser().name,
    device: parser.getDevice().type || 'pc',
    os: parser.getOS().name,
  };
  return properties;
};

export const isMobileIos = () => {
  const { device, os } = getCustomerProperties();
  return device === DEVICE_TYPE.mobile && os === 'iOS';
};

export const isIE = () => {
  const { browser } = getCustomerProperties();
  return browser === 'IE';
};

export default getCustomerProperties;
